import request from '@/utils/request'

// 文章详情
export function getArticle(data) {
  return request({
    url: `/df-module-app/article-entity/${data.id}`,
    method: 'GET',
    // data: data
  })
}

// 查看中文用户协议和隐私
export function getManagement(data) {
  return request({
    url: `/df-module-crm/article/management/read`,
    method: 'post',
    data: data
  })
}

// 安卓最新apk下载
export function downloadApk(data) {
  return request({
    url: `/df-module-crm/app-update-entity/download`,
    method: 'post',
    data: data
  })
}

// 检测记录
export function reqCheckRecordDetail(data) {
  return request({
    url: `/df-module-app/api/detectionRecord/health/detail`,
    method: 'post',
    data: data
  })
}

export function reqGetUserInfo(data) {
  return request({
    url: `/df-module-app/user-entity/selectById/${data.id}`,
    method: 'get',
    data:data
  })
}